import React from 'react';
import { Link } from 'react-router-dom';

// Public (no login) legal pages rendered from simple markdown: #/## headings, - lists, **bold**, [text](url), bare https URLs.
const FONT = 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
const inline = (text) => {
  const out = []; let rest = text; let k = 0;
  const re = /\*\*([^*]+)\*\*|\[([^\]]+)\]\((https?:[^)]+)\)|(https?:\/\/[^\s)]+)/;
  while (rest) {
    const m = rest.match(re);
    if (!m) { out.push(rest); break; }
    if (m.index) out.push(rest.slice(0, m.index));
    if (m[1]) out.push(<strong key={k++}>{m[1]}</strong>);
    else if (m[2]) out.push(<a key={k++} href={m[3]} target="_blank" rel="noreferrer" style={{ color: '#8C6D1F' }}>{m[2]}</a>);
    else out.push(<a key={k++} href={m[4]} target="_blank" rel="noreferrer" style={{ color: '#8C6D1F' }}>{m[4]}</a>);
    rest = rest.slice(m.index + m[0].length);
  }
  return out;
};
const render = (md) => {
  const blocks = []; let list = null; let para = [];
  const flushPara = () => { if (para.length) { blocks.push(<p key={blocks.length} style={{ lineHeight: 1.6, margin: '0 0 12px' }}>{para.map((l, i) => <React.Fragment key={i}>{i > 0 && <br />}{inline(l)}</React.Fragment>)}</p>); para = []; } };
  const flushList = () => { if (list) { blocks.push(<ul key={blocks.length} style={{ lineHeight: 1.6, margin: '0 0 12px', paddingLeft: 22 }}>{list.map((l, i) => <li key={i}>{inline(l)}</li>)}</ul>); list = null; } };
  md.split('\n').forEach((line) => {
    if (line.startsWith('# ')) { flushPara(); flushList(); blocks.push(<h1 key={blocks.length} style={{ fontSize: 28, margin: '0 0 8px' }}>{line.slice(2)}</h1>); }
    else if (line.startsWith('## ')) { flushPara(); flushList(); blocks.push(<h2 key={blocks.length} style={{ fontSize: 19, color: '#8C6D1F', margin: '24px 0 8px' }}>{line.slice(3)}</h2>); }
    else if (line.startsWith('- ')) { flushPara(); (list = list || []).push(line.slice(2)); }
    else if (!line.trim()) { flushPara(); flushList(); }
    else { flushList(); para.push(line); }
  });
  flushPara(); flushList();
  return blocks;
};

export default function LegalPage({ markdown }) {
  return (
    <div style={{ minHeight: '100vh', background: '#faf8f3', fontFamily: FONT, color: '#1a1a1a', padding: '0 0 40px' }}>
      <div style={{ background: '#1a1a1a', borderBottom: '3px solid #D4AF37', padding: '14px 20px' }}>
        <Link to="/" style={{ color: '#FFFFFF', textDecoration: 'none', fontWeight: 700, letterSpacing: '0.08em' }}>RESI</Link>
      </div>
      <div style={{ maxWidth: 780, margin: '24px auto', background: '#FFFFFF', border: '1px solid #d8c9a8', borderRadius: 10, padding: '28px 24px', boxSizing: 'border-box' }}>
        {render(markdown)}
      </div>
      <LegalFooter />
    </div>
  );
}

export function LegalFooter({ style }) {
  return (
    <div style={{ textAlign: 'center', fontSize: 12, color: '#7f7f7f', marginTop: 16, ...style }}>
      <Link to="/privacy" style={{ color: '#7f7f7f' }}>Privacy Policy</Link> · <Link to="/terms" style={{ color: '#7f7f7f' }}>Terms</Link> · © {new Date().getFullYear()} RESIDENCE | eXp Realty
    </div>
  );
}
